export default {
    book: 'Reservar {product}',
    age_limit: 'Apenas para maiores de {age} anos',
    change_plan: 'Mudar Plano',
    upgrade_product: 'Fazer upgrade do produto',
    upgrade: 'Fazer upgrade',
    cancel_upgrade: 'Cancelar upgrade',
    choose_product: 'Escolher {product}',
    days: '{count} dia | {count} dias',
    login_register: 'Entrar/Registrar',
    current: 'Atual',
    keyless_benefits: {
        label: 'Direto ao carro {0}',
        highlight: 'serviço de aluguel™',
        list: {
            cant_lose_the_key: 'Seguro Total',
            zero_excess: 'Franquia Zero',
            phone_as_a_key: 'Celular como Chave',
            straight_to_car: 'Sem espera',
            no_queues: 'Sem filas',
            online_id_check: 'Verificação de ID Online',
            self_checkout: 'Autoatendimento',
        },
    },
};
